export function uniqueAssignees(value: string[] = []): string[] {
  return Array.from(
    new Set(value.map((item) => String(item || "").trim()).filter(Boolean))
  );
}

export function getDefaultTaskAssignees(
  projectAssigneeIds: string[],
  currentUserId: string
): string[] {
  const allowedAssignees = uniqueAssignees(projectAssigneeIds);
  return allowedAssignees.includes(currentUserId) ? [currentUserId] : [];
}

export function taskHasAssignee(
  task: { assignees: string[] },
  userId: string
): boolean {
  return uniqueAssignees(task.assignees).includes(userId);
}

export function canViewWeeklyTask(
  project: { creator: string } | undefined,
  task: { assignees: string[] },
  viewer: { isTeamAdmin: boolean; userId: string; userRole: number }
) {
  return (
    viewer.isTeamAdmin ||
    (viewer.userRole === 1 && project?.creator === viewer.userId) ||
    taskHasAssignee(task, viewer.userId)
  );
}

export function getTaskAssigneeKey(assignees: string[] = []): string {
  return uniqueAssignees(assignees).sort().join(",");
}
